var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckIconcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M17.4 3c0-.3-.1-.6-.3-.8L15.6.6a1 1 0 0 0-.7-.3 1 1 0 0 0-.8.3L7.1 8 3.9 4.7a1 1 0 0 0-.7-.3 1 1 0 0 0-.8.3L1 6.2a1.1 1.1 0 0 0 0 1.6l5.3 5.5c.2.2.5.4.8.4l.7-.4 9.3-9.6a1.1 1.1 0 0 0 .3-.8z"
})));
export default SvgCheckIconcom;